import Dnd from '../../grid/dnd';

export default instance => {
  return (taskId, event) => {
    if (Dnd.isDragging && !taskId) {
      Dnd.dragEnd();
    }
  };
};
